import { defineComponent as _defineComponent } from 'vue'
import {computed} from "vue";

type vCardProps = {
  cardTitle: string;
  cardSubtitle?: string;
  customStyle?: string | Record<string, string | number>
}


export default /*#__PURE__*/_defineComponent({
  __name: 'vCard',
  props: {
    cardTitle: { default: '' },
    cardSubtitle: { default: '' },
    customStyle: { default: '' }
  },
  setup(__props: any) {

const props = __props as { cardTitle: string, cardSubtitle: string, customStyle: string | Record<string, string | number> };



const computedStyle = computed(() => {
  if (typeof props.customStyle === 'string') {
    return props.customStyle
  }
  return { ...props.customStyle }
})

return { __sfc: true,props, computedStyle }
}

})